import { IconChevDown } from '@ui/icons'
import { type SelectHTMLAttributes } from 'react'

type Option = {
  value: string
  label: string
  disabled?: boolean
}

type Props = Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'children' | 'size'
> & {
  options?: Option[]
  placeholder?: string
  children?: React.ReactNode
  size?: 'sm' | 'md'
}

const Select = ({
  options,
  placeholder,
  children,
  size = 'md',
  className = '',
  disabled,
  ...rest
}: Props) => {
  const height =
    size === 'sm' ? 'min-h-[36px] text-sm' : 'min-h-[44px] text-base'
  return (
    <div className="relative">
      <select
        {...rest}
        disabled={disabled}
        className={`
          appearance-none w-full
          ${height}
          pl-3 pr-9 py-2 rounded-lg
          bg-cream-card border border-ink-200
          text-ink-900
          focus:outline-none focus:border-green-700 focus:ring-2 focus:ring-green-700/20
          disabled:opacity-60
          ${className}
        `}
      >
        {placeholder !== undefined && (
          <option value="" disabled={rest.required}>
            {placeholder}
          </option>
        )}
        {options
          ? options.map((o) => (
              <option key={o.value} value={o.value} disabled={o.disabled}>
                {o.label}
              </option>
            ))
          : children}
      </select>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-ink-500"
      >
        <IconChevDown size={16} />
      </span>
    </div>
  )
}

export default Select
